// Types
import {contractDate} from '@drivesally/sally-fn/lib/types';

export default ({rental: {start_date = ''} = {}} = {}) =>
  contractDate(start_date).format();
